"use client";

import React, { useState } from "react";

import { useSearchParams } from "next/navigation";

import LoginForm from "./form";
import OTPVerification from "./otp-verification";

const steps = ["mobile-number-entry", "otp-verification"];
export default function MobileAuth() {
  const searchParams = useSearchParams();
  const step = searchParams?.get("step") ?? null;
  const mobileNumber = searchParams?.get("mobileNumber") ?? null;
  const otpId = searchParams?.get("id") ?? null;
  const [currentStep, setCurrentStep] = useState<string>(step ?? steps[0]);
  const [mobileNumberState, setMobileNumberState] = useState<number | null>(
    mobileNumber ? Number(mobileNumber) : null,
  );

  const currentStepComponent =
    currentStep === steps[0] ? (
      <LoginForm
        mobileNumber={mobileNumberState}
        onChange={(value) => setMobileNumberState(value)}
        steps={steps}
        changeStep={(step) => setCurrentStep(step)}
      />
    ) : (
      <OTPVerification
        length={6}
        onStepChange={(step) => setCurrentStep(step)}
        steps={steps}
        resendTimer={60}
        otpId={otpId || ""}
      />
    );
  return <>{currentStepComponent}</>;
}
